// extracted by mini-css-extract-plugin
module.exports = {"leaflets--twocol":"Leaflets-module__leaflets--twocol___3P0HK","leaflet":"Leaflets-module__leaflet___ZFFa8"};